// extracted by mini-css-extract-plugin
export default {"description":"description---o1j0m"};